import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1C3326] text-[#FDFBF7]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <picture>
              <source srcSet="/logo.webp" type="image/webp" />
              <img
                src="/logo.png"
                alt="SIGA Coffee"
                width="800"
                height="174"
                className="h-14 w-auto mb-8"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </picture>
            <h2 className="font-serif-display text-5xl md:text-6xl leading-none font-light">
              Farm to Cup.<br />Crafted for India.
            </h2>
            <p className="mt-6 max-w-md text-[#EBE3D5] leading-relaxed">
              SIGA Coffee — flagship brand of <span className="text-[#C85A32]">Explora E-Trades Pvt. Ltd.</span>{" "}
              End-to-end coffee solutions for cafés, hotels, offices, and retail. Estate-sourced,
              small-batch roasted in Chikkamagaluru.
            </p>
            <a
              href="https://www.instagram.com/sigacoffee/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 mt-8 text-xs uppercase tracking-[0.25em] link-underline"
              data-testid="footer-instagram"
            >
              <Instagram size={14} /> Instagram
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#C85A32] mb-4">Shop</div>
            <ul className="space-y-2 text-sm">
              <li><Link className="link-underline" to="/shop?category=arabica">Arabica</Link></li>
              <li><Link className="link-underline" to="/shop?category=robusta">Robusta</Link></li>
              <li><Link className="link-underline" to="/shop?category=blends">Blends</Link></li>
              <li><Link className="link-underline" to="/shop?category=decaf">Decaf</Link></li>
              <li><Link className="link-underline" to="/shop?category=equipment">Equipment</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#C85A32] mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link className="link-underline" to="/about">About SIGA</Link></li>
              <li><Link className="link-underline" to="/business">For Business</Link></li>
              <li><Link className="link-underline" to="/services">Experiences</Link></li>
              <li><Link className="link-underline" to="/account">Account</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#C85A32] mb-4">Reach us</div>
            <p className="text-sm text-[#EBE3D5] leading-relaxed">
              Explora E-Trades Pvt. Ltd.<br />
              Bengaluru, Karnataka, India<br />
              Estates: Chikmagalur · Sakleshpur · The Nilgiris<br />
              Roasted in Chikkamagaluru<br />
              help@sigacoffee.com
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#EBE3D5]/20 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-[#EBE3D5]/70">
          <div>© {new Date().getFullYear()} SIGA Coffee · Explora E-Trades Pvt. Ltd.</div>
          <div className="uppercase tracking-[0.2em]">B2B · Retail · Café Solutions · Nationwide</div>
        </div>
      </div>
    </footer>
  );
}
